module.exports = __webpack_public_path__ + "static/preview-99b9ccfe7b7ac47fa6518d7b6650b613.png";